"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setMailboxCalendarConfigurationOperation_1 = require("owa-service/lib/operation/setMailboxCalendarConfigurationOperation");
var setMailboxCalendarConfigurationRequest_1 = require("owa-service/lib/factory/setMailboxCalendarConfigurationRequest");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
function setMailboxCalendarConfiguration(options) {
    return setMailboxCalendarConfigurationOperation_1.default(setMailboxCalendarConfigurationRequest_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Options: options,
    }));
}
exports.default = setMailboxCalendarConfiguration;
//# sourceMappingURL=setMailboxCalendarConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/owa-calendar-configuration/lib/services/setMailboxCalendarConfiguration.js
// module id = 5252
// module chunks = 2